export default {
  groupName: 'adpi-category-wireless',
  appName: 'Wireless Category',
  baseRoute: '/dashboard/adpi-category-wireless',
  label: 'Ad Effect Wireless Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Ad Effect Wireless Dashboard'
};



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryWireless/config/main.js